// Shared media-kit accent themes — used by the editor, live preview, public page and PDF.
export const MEDIA_KIT_THEMES = {
  emerald: { label: "Emerald", accent: "#0f8a60", gradFrom: "#059669", gradTo: "#047857", rgb: [15, 138, 96] },
  ocean:   { label: "Ocean",   accent: "#0369a1", gradFrom: "#0284c7", gradTo: "#075985", rgb: [3, 105, 161] },
  indigo:  { label: "Indigo",  accent: "#4f46e5", gradFrom: "#6366f1", gradTo: "#4338ca", rgb: [79, 70, 229] },
  berry:   { label: "Berry",   accent: "#be185d", gradFrom: "#db2777", gradTo: "#9d174d", rgb: [190, 24, 93] },
  sunset:  { label: "Sunset",  accent: "#c2410c", gradFrom: "#f97316", gradTo: "#c2410c", rgb: [194, 65, 12] },
  gold:    { label: "Gold",    accent: "#b45309", gradFrom: "#f59e0b", gradTo: "#b45309", rgb: [180, 83, 9] },
  teal:    { label: "Teal",    accent: "#0f766e", gradFrom: "#14b8a6", gradTo: "#0f766e", rgb: [15, 118, 110] },
  charcoal:{ label: "Charcoal",accent: "#334155", gradFrom: "#475569", gradTo: "#1e293b", rgb: [51, 65, 85] },
};

export const THEME_KEYS = Object.keys(MEDIA_KIT_THEMES);

export function getTheme(key) {
  return MEDIA_KIT_THEMES[key] || MEDIA_KIT_THEMES.emerald;
}
